import React, { useContext, useEffect, useRef, useState } from "react";
import Carosle from "./Components/Carosle";
import MenuList from "./Components/MenuList";
import HeaderInner from "./Components/HeaderInner";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import CustomLoader from "./Components/Loaders/CustomLoader";
import { ShowHomeMenu } from "./API/HomeMenuAPI";
import ErrorPage from "./Components/ErrorPage";
import Footer from "./Components/Footer";
import axios from "axios";
import { ThemeContext } from "./context/ThemeContext";
import { useBusinessNameContext } from "./context/BusinessName";
import AppPopup from "./Components/AppPopup";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useGlobalContext } from "./context/GlobalContext";
import DOMPurify from "dompurify";
import { Skeleton } from "primereact/skeleton";
import HomeLoader from "./Components/Loaders/HomeLoader";

const formatInStayName = (value) =>
  typeof value === "string" ? value.replace(/^In Stay\b/, "In-Stay") : value;

function HomeMenu() {
  const { businessName, setBusinessName } = useBusinessNameContext();
  const { t } = useTranslation();
  const { setHeaderImages } = useGlobalContext();
  const business_name = localStorage.getItem("business_name");

  const lang = sessionStorage.getItem("lang");
  const params = useParams();
  const [isVerticalVideo, setIsVerticalVideo] = useState(false);
  const { theme, setTheme } = useContext(ThemeContext);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMedia, setPopupMedia] = useState({ type: null, src: null });
  // const { setTheme } = useContext(ThemeContext);

  console.log("themethemethemethemethemetheme", theme);

  const colorRef = useRef(null);
  let menu;
  let bgColor;
  let color;
  let headerImages;
  let logo;
  let services;
  let languages;
  let guest_directory_service;
  let has_extra_services;
  let show_wifi_access = false;
  let show_printing_service = false;
  let notFound = "";
  const navigate = useNavigate();
  const { data, isLoading, error } = ShowHomeMenu(params.room_uuid, lang);
  const isQrExpired = error?.response?.status === 404;

  useEffect(() => {
    if (isQrExpired) {
      navigate(`/${params.room_uuid}/qr-scan`, {
        replace: true,
      });
    }
  }, [isQrExpired, navigate, params.room_uuid]);
  // console.log("data", data.data);
  if (!isLoading && data?.data) {
    if (data.data.status === false) {
      navigate(`/${params.room_uuid}/qr-scan`);
      // notFound = "Room Not Found";
    } else {
      menu = data.data.data;
      guest_directory_service = menu.guest_directory;

      languages = menu.languages;
      // const images = menu?.header_images.map((image) => {
      //   return image.image;
      // });
      headerImages = menu.realvideo
        ? [{ image: menu.realvideo }, ...menu?.header_images]
        : menu?.header_images;
      logo = menu?.logo;
      show_wifi_access = menu?.show_wifi_access;
      // show printing service
      show_printing_service = menu?.show_printing_service;

      services = data?.data?.data?.activeServices?.map((service) => ({
        ...service,
        name: formatInStayName(service?.name),
        service_name: formatInStayName(service?.service_name),
        display_name: formatInStayName(service?.display_name),
      }));
      localStorage.setItem("has_extra_services", menu?.has_extra_services);
      localStorage.setItem(
        "is_grand_millennium_barsha_hotel",
        menu?.is_grand_millennium_barsha_hotel
      );
      has_extra_services = menu?.has_extra_services;
      bgColor = menu?.header_color;
      color = menu?.color;
      // console.log("menumenu", menu);
      localStorage.setItem("logo", logo);
      localStorage.setItem("countryCode", menu?.country_code || "ae");

      // colorRef.current.style.setProperty('--color', menu?.color);
      document.documentElement.style.setProperty("--color", menu?.color);
      document.documentElement.style.setProperty(
        "--color_t",
        `${menu?.color}b3`
      );
      document.documentElement.style.setProperty(
        "--color_car",
        `${menu?.color}69`
      );
    }
    // localStorage.setItem("color", color)
    // localStorage.setItem("bgcolor", bgColor)
  }
  useEffect(() => {
    if (!isLoading && data?.data?.data) {
      const menu = data.data.data;
      setTheme(menu.use_new_design);
      const imgs = menu.realvideo
        ? [{ image: menu.realvideo }, ...menu?.header_images]
        : menu?.header_images;
      setHeaderImages(imgs);
    }
  }, [isLoading, data]);

  // Show popup when data loads with video or image
  useEffect(() => {
    if (!isLoading && data?.data?.data) {
      const menu = data.data.data;
      if (menu.real_popup_video) {
        setPopupMedia({ type: "video", src: menu.real_popup_video });
        setPopupOpen(true);
      } else if (menu.real_popup_image) {
        setPopupMedia({ type: "image", src: menu.real_popup_image });
        setPopupOpen(true);
      } else if (menu.real_popup_text) {
        setPopupMedia({ type: "text", src: menu.real_popup_text });
        setPopupOpen(true);
      }
    }
  }, [isLoading, data]);
  // useEffect(() => {
  //   const getData = async () => {
  //     // axios.get(`/648ed77e-da78-4987-9b86-de515659fc2c`).then((res) => {
  //     setLoading(true);

  //     axios.get(`/${params.room_uuid}`).then((res) => {
  //       const data = res?.data.data;
  //       if (res.data.status == false) {
  //         setError(res.data.message)
  //       }
  //       // console.log("res", res);
  //       setHeaderImages(data?.header_images);
  //       setLogo(data?.logo);
  //       setServices(data?.activeServices);
  //       setLoading(false);
  //       // console.log("d", data);
  //     }).catch((err) => {
  //       setLoading(false);
  //       setError(err?.message)
  //       // console.log("err", err);
  //     })
  //   };
  //   getData();
  // }, []);
  const showData = () => {
    // if (isLoading || isFetching) {
    //   return <CustomLoader businessName={businessName} />;

    if (isLoading || (!data && !error) || isQrExpired) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              maxWidth: "600px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <HomeLoader />{" "}
          </div>
        </div>
      );
    }

    if (error) {
      return <ErrorPage des={error} />;
    }
    // if (notFound) {
    //   return <ErrorPage des={notFound} />;
    // }
    return (
      <>
        <HeaderInner
          logo={logo}
          bgColor={bgColor}
          color={color}
          languages={languages}
        />
        <main className="home-main pad-top-0">
          {businessName &&
            (businessName == "Grand Continental Hotel" ||
              businessName == "Royal M Hotel & Resort Abu Dhabi by Gewan") && (
              <AppPopup />
            )}
          <Carosle
            className={"dot-bar less-margin small-dots"}
            headerImages={headerImages}
            isFirst={true}
          />
          <div className="spacer-10 full-div"></div>
          <MenuList
            services={services}
            loading={isLoading}
            has_extra_services={has_extra_services}
            show_wifi_access={show_wifi_access}
            show_printing_service={show_printing_service}
            guest_directory_service={guest_directory_service}
          />{" "}
          {/* <pre>{JSON.stringify(services, null, 2)}</pre> */}
        </main>
        {/* <Footer /> */}
      </>
    );
  };

  return (
    <>
      {/* <HeaderInner logo={logo} bgColor={bgColor}
        color={color} /> */}
      {/* <main className="home-main pad-top-0"> */}
      {showData()}

      {/* </main> */}

      {/* Popup Modal for Video/Image */}
      <Modal
        show={popupOpen}
        onHide={() => setPopupOpen(false)}
        centered
        className={`${
          theme && "food-modal"
        } banner_popup home-banner-popup p-0`}
        style={{
          paddingRight: 0,
        }}
      >
        <Modal.Body
          style={{
            padding: "16px",
          }}
        >
          <div style={{ width: "100%", height: "100%", position: "relative" }}>
            <div>
              <button
                onClick={() => setPopupOpen(false)}
                className="popup-close-btn"
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  border: "none",
                  background: "var(--color)",
                  color: "white",
                  width: "35px",
                  height: "35px",
                  borderRadius: "50%",
                  fontSize: "10px",
                  padding: "7px",
                  cursor: "pointer",
                  zIndex: 10,
                }}
              >
                <svg
                  className="w-5 h-5 text-gray-400"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
            {popupMedia.type === "video" && (
              <div
                className="video-container"
                style={{
                  height: isVerticalVideo ? "90vh" : "auto",
                  maxWidth: "85vw",
                  maxHeight: "80vh",
                }}
              >
                <video
                  autoPlay
                  muted
                  playsInline
                  loop
                  onLoadedMetadata={(e) => {
                    const video = e.target;
                    setIsVerticalVideo(video.videoHeight > video.videoWidth);
                  }}
                >
                  <source src={popupMedia.src} type="video/mp4" />
                </video>
              </div>
            )}
            {popupMedia.type === "image" && (
              <img
                src={popupMedia.src}
                alt="Popup"
                style={{
                  width: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
              />
            )}
            {popupMedia.type === "text" && (
              <div
                style={{
                  textAlign: "center",
                  padding: "20px 0px",
                  marginTop: "35px",
                  maxWidth: "90vw",
                }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    String(popupMedia.src.replace(/\n/g, "<br>"))
                  ),
                }}
              />
            )}
            {/* <div
              className={`${theme ? "banner-book" : "reg-btn"}`}
              style={{
                marginTop: "15px",
                textAlign: "center",
              }}
            >
              <a onClick={() => setPopupOpen(false)}>{t("Dismiss")}</a>
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default HomeMenu;
